<div class="modal-content-wrapper" [ngClass]= "modalConfig?.panelClass">
    <div class="modal-header">
    <h4 *ngIf="modalConfig?.headingAlign !== 'left'" class="w-100 text-center">
      {{ modalConfig?.heading }}
    </h4>
    <h6 *ngIf="modalConfig?.headingAlign === 'left'" class="w-100 text-start font-weight-bold mb-0">
      {{ modalConfig?.heading }}
    </h6>
    <div class="btn-modal-close cursor-pointer" *ngIf="!modalConfig?.hideCloseIcon">
        <img src="assets/images/neveda-images/close.svg" id="close_img" (click)="closeModal('N')"
            (keypress)="closeModal('N')" alt="close_icon" tabindex="0">
    </div>
</div>
<div class="modal-body">
    <div class="modal-content-wrapper" [ngClass]="{'scrollable-content': modalConfig?.scrollable}">
        <div *ngIf="modalConfig?.showLogo" class="row justify-content-center mt-2 mb-4">
            <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
                <img [src]="modalConfig?.logoSrc" alt="NDE logo" class="img-fluid" />
            </div>
        </div>
        <div *ngIf="modalConfig?.hasDropdown" class="col-md-6 col-6 mb-3 pl-0">
            <label aria-labelledby="staffMember" for="staffMember" class="dropdown-label">
                {{ modalConfig?.dropdownLabel }}
                <span class="requiredfield text-danger">*</span>
            </label>
            <p-dropdown
                inputId="staffMember"
                [options]="modalConfig?.dropdownOptions"
                placeholder="Select Assignee"
                [(ngModel)]="selectedStaffMember"
                styleClass="w-100"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                (onChange)="onDropdownChange()"
                (onBlur)="onDropdownFocusOut()">
            </p-dropdown>
            <div *ngIf="dropdownError" class="text-danger font-14 mt-1">{{ dropdownError }}</div>
        </div>
        <div *ngIf="modalConfig?.modalContent">
            <div *ngIf="!modalConfig?.hasTemplate; else showTemplate"
            [ngClass]="[modalConfig?.align ? 'text-start' : 'text-center', modalConfig?.modalContentClass ? modalConfig?.modalContentClass : '']" class="font-noto font-18 card-text mb-0"
            [innerHTML]="modalConfig.modalContent"></div>
      
            <ng-template #showTemplate>
                <div [innerHTML]="modalConfig?.modalContent" class="template-content" 
                [ngClass]="modalConfig?.modalContentClass ? modalConfig?.modalContentClass : ''"></div>
            </ng-template>
        </div>
        <div *ngIf="modalConfig?.modalContentArray && modalConfig?.modalContentArray.length > 0">
            <ng-container *ngFor="let inputField of modalConfig?.modalContentArray">
                 <div *ngIf="!modalConfig?.hasTemplate; else showTemplate"
                [ngClass]="[modalConfig?.align ? 'text-start' : 'text-center', inputField?.contentClass ? inputField?.contentClass : '']" class="font-noto font-18 card-text mb-0"
                [innerHTML]="inputField.content"></div>
      
                <ng-template #showTemplate>
                    <div [innerHTML]="inputField?.content" class="template-content" 
                    [ngClass]="inputField?.contentClass ? inputField?.contentClass : ''"></div>
                </ng-template>
            </ng-container>
        </div>
        <div *ngIf="modalConfig?.confirmContent"> 
            <div class="info-box info-box-grid">
                <ng-container *ngFor="let key of modalConfig?.confirmContent">
                    <div class="info-label"><strong>{{key.label}}</strong></div>
                    <span>:</span>
                    <div class="info-value">{{key.value}}</div>
                </ng-container>
            </div>
        </div>
        <div *ngIf="modalConfig?.modalInputArray?.length > 0" class="mt-3">
            <ng-container *ngFor="let inputField of modalConfig?.modalInputArray">
                <div [ngClass]="{'mb-3': !inputField?.error, 'signature-section': inputField.fieldName === 'strFullName'}">
                    <label class="form-label" for="{{inputField?.fieldName}}" [innerHTML]="inputField?.label"></label>
                    <ng-container *ngIf="inputField.fieldName === 'strFullName'">
                        <button type="button" class="ml-1 tooltip-icon" tabindex="0" *ngIf="inputField.tooltip"
                        [attr.aria-describedby]="showSignatureTooltip ? 'signatureTooltipContent' : null"
                        [attr.aria-expanded]="showSignatureTooltip"
                        (click)="toggleSignatureTooltip && toggleSignatureTooltip()"
                        (mouseenter)="openSignatureTooltip && openSignatureTooltip()"
                        (mouseleave)="closeSignatureTooltip && closeSignatureTooltip()"
                        title="First and last name only. Do not include middle name or suffix.">
                        <span  class="material-symbols-outlined f-16" aria-hidden="true">info</span>
                        <span class="sr-only">info</span>
                        </button>
                        <span *ngIf="showSignatureTooltip" class="material-symbols-outlined inverted-arrow"
                         style="position:absolute; top:-16px; left:50%; transform:translateX(-50%);" aria-hidden="true">
                        arrow_drop_down
                        </span>
                    </ng-container>
                    <div class="input-wrapper">
                        <input type="{{inputField?.type}}" 
                            class="signature-input" 
                            [class.error]="signatureErrors[inputField.fieldName]" 
                            [class.valid]="signatureValid[inputField.fieldName]"
                            [(ngModel)]="inputField.value" 
                            (ngModelChange)="onInputChange(inputField)"
                            [placeholder]="inputField?.placeholder ? inputField?.placeholder : ''"
                            [attr.title]="inputField?.tooltip ? inputField.tooltip : ''"
                            id="{{inputField?.fieldName}}"
                            (blur)="inputField.fieldName === 'strFullName' && onSignatureFocusOut(inputField)"/>
                        <span *ngIf="signatureValid[inputField.fieldName]" class="material-symbols-outlined signvalid">
                            task_alt
                        </span>
                        <img *ngIf="signatureErrors[inputField.fieldName]" 
                            src="assets/images/exclamation.svg" 
                            alt="Error" 
                            class="exclamation-icon" />
                    </div>
                </div>
                <div *ngIf="inputField?.error" class="font-13 mt-1"  [innerHTML]="inputField?.error"></div>
                <div *ngIf="inputField?.content" class="font-13 help-text" [innerHTML]="inputField?.content">
                </div>
            </ng-container>
        </div>
    </div>
</div>
<div class="modal-footer">
    <div *ngIf="modalConfig?.buttons && modalConfig?.buttons.length > 0" class="modal-flex-button flex-fill">
        <ng-container *ngFor="let modalButton of modalConfig?.buttons">
            <button type="button" (click)="closeModal(modalButton?.code, modalButton?.navigate)" id="{{modalButton?.text}}" 
                [ngClass]="getButtonClasses(modalButton)"
                [disabled]="modalButton?.code === 'Y' && isAssignButtonDisabled()">
                {{ modalButton?.text }}
            </button>
        </ng-container>
    </div>
</div>
</div>